import { NgModule } from '@angular/core';
import { PasswordResetComponent } from './password-reset.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValidatorsModule } from '../../validators/validators.module';
import { FormFeedbackModule } from '../../main/shared/form-feedback/form-feedback.module';

@NgModule({
  declarations: [
    PasswordResetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ValidatorsModule,
    FormFeedbackModule,
  ],
  exports: [
    PasswordResetComponent
  ]
})
export class PasswordResetModule { }
